/* eslint-disable react-hooks/exhaustive-deps */
// components/PermissionManager.js
import React, { useState, useEffect } from 'react';
import './PermissionManager.scss';
import AdminServices from '../../services/AdminServices';
import * as Storage from '../../services/LocalStorage';
import { useSelector } from 'react-redux';

const PermissionManager = () => {
    const { config: reduxConfig } = useSelector((state) => state.config);
  const [permissions, setPermissions] = useState({
    restaurant: [],
    customer: []
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [accessChecked, setAccessChecked] = useState(false);

  // Define all available components with their details
  const allComponents = [
    { component: 'dashboard', name: 'Dashboard', path: '/dashboard', icon: 'fa-solid fa-list' },
    { component: 'finance', name: 'Finance', path: '/finance', icon: 'fa-sharp fa-solid fa-coins' },
    { component: 'orders', name: 'Orders', path: '/orders', icon: 'fa-brands fa-jedi-order' },
    { component: 'party-orders', name: 'Party Orders', path: '/party-orders', icon: 'fa-brands fa-first-order' },
    { component: 'menu', name: 'Menu', path: '/menu', icon: 'fa-solid fa-bars' },
    { component: 'tags', name: 'Tags', path: '/tags', icon: 'fa-solid fa-tags' },
    { component: 'delivery', name: 'Delivery', path: '/delivery', icon: 'fa-solid fa-truck' },
    { component: 'profile', name: 'Profile', path: '/profile', icon: 'fa-solid fa-address-book' },
    { component: 'banking-details', name: 'Bank Info', path: '/banking-details', icon: 'fa-solid fa-building-columns' },
  ];

  const checkAdminAccess = () => {
    try {
      // Get admin data from storage
      const adminData = Storage.get('foodAdminData');
      const config = reduxConfig;

      console.log('Admin check - adminData:', adminData, 'config:', config);
      
      if (!adminData) {
        console.log('No admin data found');
        return false;
      }
  
const parsedAdminData = typeof adminData === 'string' ? JSON.parse(adminData) : adminData;
      // const parsedConfig = config && typeof config === 'string' ? JSON.parse(config) : config; 
      const parsedConfig = config; // Use the Redux object directly
      
      // SIMPLIFIED ADMIN CHECK - Focus on the essential conditions
      const isAdminUser = 
        (parsedAdminData.role === 'admin') || 
        (parsedConfig && parsedConfig.source === 'admin');
      
      console.log('Is admin user:', isAdminUser);
      
      if (!isAdminUser) {
        return false;
      }
  
      // Check if token exists
      if (!parsedAdminData.token) {
        console.log('No admin token found');
        return false;
      }
  
      setIsAdmin(true);
      return true;
    } catch (error) {
      console.error('Error checking admin access:', error);
      return false;
    }
  };

  // In PermissionManager.js, add this at the start of the component
  console.log('=== PermissionManager Mounted ===');
  console.log('Current storage - foodAdminData:', Storage.get('foodAdminData'));
  console.log('Current storage - appConfig:', reduxConfig   );

  // Add this to see what's happening during the check
  useEffect(() => {
    console.log('=== PermissionManager useEffect triggered ===');
    const adminAccess = checkAdminAccess();
    console.log('Final admin access decision:', adminAccess);
    setAccessChecked(true);
    
    if (!adminAccess) {
      console.log('Will redirect to dashboard');
      return;
    }
    fetchPermissionsByRole("restaurant");
    fetchPermissionsByRole("customer")
  }, []);

  const fetchPermissionsByRole = async (role) => {
    try {
      setLoading(true);
  
      // Fetch permissions for the specific role
      const response = await AdminServices.getPermissionsByRole({ role });
  
      if (response.success && response.data) {
        const rolePerms = response.data.data.permissions || [];
  
        // Map all components and mark checked if present in the DB array
        const merged = allComponents.map(comp => ({
          ...comp,
          isActive: rolePerms.some(p => p.component === comp.component)
        }));
  
        // Update state
        setPermissions(prev => ({
          ...prev,
          [role]: merged
        }));
      } else {
        // fallback if no permissions returned
        setPermissions(prev => ({
          ...prev,
          [role]: allComponents.map(comp => ({ ...comp, isActive: false }))
        }));
      }
    } catch (error) {
      console.error(`Error fetching permissions for role ${role}:`, error);
      setPermissions(prev => ({
        ...prev,
        [role]: allComponents.map(comp => ({ ...comp, isActive: false }))
      }));
    } finally {
      setLoading(false);
    }
  };
  

  const handlePermissionChange = (role, component, isActive) => {
    setPermissions(prev => ({
      ...prev,
      [role]: prev[role].map(perm => 
        perm.component === component 
          ? { ...perm, isActive }
          : perm
      )
    }));
  };

  const handleSelectAll = (role, select) => {
  console.log(role);
    setPermissions(prev => ({
      ...prev,
      [role]: prev[role].map(perm => ({
        ...perm,
        isActive: select
      }))
    }));
  };
  

  const savePermissions = async (role) => {
    try {
      setSaving(true);
      setSaveStatus('');
  
      // Only save components that the admin selected
      const selectedPermissions = permissions[role].filter(perm => perm.isActive);
  
      // Prepare request data
      const requestData = {
        role: role,
        permissions: selectedPermissions.map(perm => ({
          component: perm.component,
          name: perm.name,
          path: perm.path,
          icon: perm.icon
        }))
      };
  
      console.log('Updating permissions for role:', role, 'with data:', requestData);
  
      const response = await AdminServices.updatePermissions(requestData);
  
      if (response.success) {
        setSaveStatus(`Permissions for ${role} saved successfully!`);
        setTimeout(() => setSaveStatus(''), 3000);
      } else {
        setSaveStatus(`Error: ${response.message || 'Failed to save permissions'}`);
      }
    } catch (error) {
      console.error('Error saving permissions:', error);
      setSaveStatus('Error saving permissions. Please try again.');
    } finally {
      setSaving(false);
    }
  };
  

  const renderRoleSection = (role) => {
    const rolePermissions = permissions[role] || [];
    const activeCount = rolePermissions.filter(p => p.isActive).length;
    const totalCount = rolePermissions.length;

    return (
      <div className="role-section" key={role}>
        <div className="role-header">
          <div className="role-title">
            <h3>{role.charAt(0).toUpperCase() + role.slice(1)} Permissions</h3>
            <span className="active-count">
              {activeCount} of {totalCount} components enabled
            </span>
          </div>
          <div className="role-actions">
            <button
              className="btn-select-all"
              onClick={() => handleSelectAll(role, true)}
            >
              Select All
            </button>
            <button
              className="btn-deselect-all"
              onClick={() => handleSelectAll(role, false)}
            >
              Deselect All
            </button>
            <button
              className="btn-save"
              onClick={() => savePermissions(role)}
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>

        <div className="permissions-grid">
          {rolePermissions.map(permission => (
            <div
              key={`${role}-${permission.component}`}
              className={`permission-item ${permission.isActive ? 'active' : ''}`}
            >
              <label className="permission-label">
                <input
                  type="checkbox"
                  checked={permission.isActive || false}
                  onChange={(e) => 
                    handlePermissionChange(role, permission.component, e.target.checked)
                  }
                  className="permission-checkbox"
                />
                <div className="permission-content">
                  <div className="permission-icon">
                    <i className={permission.icon}></i>
                  </div>
                  <div className="permission-details">
                    <span className="permission-name">{permission.name}</span>
                    <span className="permission-path">{permission.path}</span>
                  </div>
                </div>
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Show loading or redirect if not admin
  if (!accessChecked) {
    return (
      <div className="permission-manager loading">
        <div className="loading-spinner"></div>
        <p>Checking access...</p>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="permission-manager loading">
        <div className="loading-spinner"></div>
        <p>Redirecting...</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="permission-manager loading">
        <div className="loading-spinner"></div>
        <p>Loading permissions...</p>
      </div>
    );
  }

  return (
    <div className="permission-manager">
      <div className="permission-header">
        <h1>Permission Management</h1>
        <p>Control which sidebar components are visible to different user roles</p>
        
        {saveStatus && (
          <div className={`save-status ${saveStatus.includes('Error') ? 'error' : 'success'}`}>
            {saveStatus}
          </div>
        )}
      </div>

      <div className="permissions-container">
        {renderRoleSection('restaurant')}
        {renderRoleSection('customer')}
      </div>
    </div>
  );
};

export default PermissionManager;